import { PayloadAction } from "@reduxjs/toolkit";
import { PlanningState } from "./interfaces";


export const reducers = {
    setPlaningTask: (state:PlanningState , action: PayloadAction<any>) => {
        state.planingTask = action.payload;
    }
};